import script from "./BotInventoryReport.vue?vue&type=script&setup=true&lang=js"
export * from "./BotInventoryReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__